/* eslint eqeqeq: "off" */
import React from 'react';
import {connect} from 'react-redux';
import PagosLinea from './PagosLinea';
import {bindActionCreators} from 'redux';
import * as tagActions from '../../actions/tagActions';
import * as paginaActions from '../../actions/paginaActions';
import * as pagosActions from '../../actions/pagosActions';

import * as inscripcionActions from '../../actions/inscripcionActions';
import {Auth} from 'aws-amplify';
import * as cursoActions from '../../actions/cursoActions';
import { withAuthenticator } from '@aws-amplify/ui-react'
import toastr from 'toastr';
import ManageList from '../common/ManageList';
import * as menuActions from '../../actions/menuActions'; 
import * as userActions from '../../actions/userActions';
import ModalMetodosPago from './ModalMetodosPago';
import { Segment} from 'semantic-ui-react';
import ModalSiNo from '../common/ModalSiNo';
import $ from 'jquery';
import moment from 'moment';
import * as showSidebarIzquierdaActions from '../../actions/showSidebarIzquierdaActions';
import * as usuarioActions from '../../actions/usuarioActions';
import * as usuariocursoActions from '../../actions/usuariocursoActions';

import {usuarioActualMiEspacio, validaApiToken} from '../../util';
 

import {getMargenes, getMargenesBlack} from '../../util/';



class ManagePagosLinea extends React.Component {
    constructor(props, context) {
		
		super(props, context);
       
   
        
        
        this.state={
            modalMetodosPago:false,
            errors:{},
            strings:{},
            showActivos:true,
            filtrosCombo:{},
            permisos:{},
            pagosLista:[],
            pagoLiquidar:{id:0}, 
            cursosPrevios:[],
            cursosActuales: [],
            constancias:[],
            cursoPago:{
                price:0,
                descripcion:null
            },
            pago:{},
            showDeposito:0
		};
	}
    
    

	componentDidMount(){
       
        usuarioActualMiEspacio(this, "Miespacio",true).then( (usuario)=>{
           window.scrollTo(0, 0);
            this.props.showSidebarIzquierdaActions.sidebarIzquierda(true);    
        })
        .catch(error=>{
          toastr.error(error);
        }); 
      
        
        
        
	}
    
    showModalMetodosPago=()=>{
        
        this.setState({"modalMetodosPago":true})
    }
    
    colesModalMetodosPago=()=>{
        this.setState({"modalMetodosPago":false})
    }
    
    init=()=>{
        
                
                this.props.cursoActions.getCursosActuales(this.props.user).then( cursosActuales=>{
                       this.setState({"cursosActuales":cursosActuales});
                })
                .catch(error=>{
                    toastr.error(error);
                });
        
                
        
             
    }
    
    handleChangeDeposito=(id)=>{
        
        let pagoLiquidar={id:0};
        let cursoPago={
                price:0,
                descripcion:null
            };
        this.setState({pagoLiquidar:pagoLiquidar, cursoPago:cursoPago});
        this.onShowDeposito(id);
    }
    
    
    handleChange=(id)=>{
        
        //console.log("pago:"+id);
        let pagoLiquidar = this.state.pagoLiquidar;
        let cursoPago = this.state.cursoPago;
        let pagoLiquidarIndex = this.state.pagosLista.findIndex(pagos=>pagos.id == id);
        pagoLiquidar = this.state.pagosLista[pagoLiquidarIndex];
        cursoPago.price = Number(pagoLiquidar.montoPago).toFixed(2);
        //cursoPago.price = 10;
        cursoPago.descripcion = pagoLiquidar.curso;
        cursoPago.reference_id = pagoLiquidar.id;
        cursoPago.idInscripcion = pagoLiquidar.inscripcionId;
        
        this.setState({pagoLiquidar:pagoLiquidar, cursoPago:cursoPago});
        
        
        this.onShowDeposito(0);
        
    }
    
    
    handleApprove = (orderID, order)=>{
            let pago = this.state.pago;
            pago.id =this.state.pagoLiquidar.id
            pago.referencia = order.purchase_units[0].payments.captures[0].id;
            pago.cadena = Object.assign({},order);
            pago.cadena=JSON.stringify(pago.cadena);
            //pago.fechaPago = new moment(order.update_time).format('DD/MM/YYYY');
            pago.pagado=1;
            
            
           validaApiToken(this).then( (userToken)=>{
                this.props.pagosActions.save(pago, userToken).then(() => {
                    toastr.success("Pago registrado!!!.");
                    
                     this.props.pagosActions.getPagosUsuario(userToken).then((pagos)=>{
                            this.setState({pagosLista:pagos});
                        }) 
                            .catch(error=>{ 
                              toastr.error(error); 
                        });
                    
                })
                .catch(error=>{
                    toastr.error(error);
                });
            }).catch(error=>{
                toastr.error(error);
            });
             
    }
    
    
    onShowDeposito=(show)=>{
        
        let showDeposito = this.state.showDeposito;
        
        showDeposito=show;
        
        this.setState({showDeposito:showDeposito});
    }
    
    render() {
        let margenes=getMargenes(this.props.showSidebarIzquierda, this.props.sidebarIzquierda);
		
		return (
            
            <Segment style={margenes} >
                  
                <PagosLinea
                    modulos={this.state.modulos}
                    strings={this.props.strings}
                    ajaxCallInProgress={this.props.ajaxCallInProgress}
                     permisos={this.state.permisos}
                    cursosActuales={this.state.cursosActuales}
                    cursosPrevios={this.state.cursosPrevios}
                    constancias={this.state.constancias}
                    userInfo={this.state.userInfo}
                    prueba={this.state.prueba}
                    showModalMetodosPago={this.showModalMetodosPago}
                    pagosLista={this.state.pagosLista}
                    handleChangePago={this.handleChange}
                    pagoLiquidar={this.state.pagoLiquidar}
                    cursoPago={this.state.cursoPago}
                    handleApprove={this.handleApprove}
                    onShowDeposito={this.onShowDeposito}
                    showDeposito={this.state.showDeposito}
                    onChangeDeposito={this.handleChangeDeposito}
                />
            
                <ModalMetodosPago
                showModal={this.state.modalMetodosPago} 
                closeModal={this.colesModalMetodosPago}
            />
            </Segment> 
            
		);
	}
    
}

            
            
function mapStateToProps(state, ownProps){
    return {   
        showSidebarIzquierda: state.showSidebarIzquierda,
        sidebarIzquierda: state.sidebarIzquierda,
        ajaxCallInProgress:state.ajaxCallInProgress,
        color:state.color,
        form:state.form,
        strings:state.strings,
        idioma:state.idioma,
        menu:state.menu,
        user:state.user
    }

}

function mapDispatchToProps(dispatch){

	return {  
        pagosActions: bindActionCreators(pagosActions, dispatch),
        menuActions: bindActionCreators(menuActions, dispatch),
        cursoActions: bindActionCreators(cursoActions, dispatch),
        paginaActions: bindActionCreators(paginaActions, dispatch),
        userActions: bindActionCreators(userActions, dispatch),
        usuarioActions: bindActionCreators(usuarioActions, dispatch),
        inscripcionActions: bindActionCreators(inscripcionActions, dispatch),
        showSidebarIzquierdaActions: bindActionCreators(showSidebarIzquierdaActions, dispatch),
        usuariocursoActions: bindActionCreators(usuariocursoActions, dispatch),
 	};
}


export default connect (mapStateToProps, mapDispatchToProps)(withAuthenticator(ManagePagosLinea));